import { ParameterCategory } from "components/CC/UI/ParameterPicker/ParameterPicker";

export const FORMULA_PICKER_TOKENS = ["commission", "value", "parent", "price"] as const;

export const PAYOUT_FORMULA_PLACEHOLDER = "( {value} * 0,0275 ) + ( {price} * 0,005 )";

/**
 * Static picker category for the commission Amount (payout_formula) field when Formula Type is
 * "formula" — its own "Formulas" tab in the picker. Shared by the create/edit commission form and
 * the inline table cell editor, so both offer the exact same picker.
 */
export const createFormulaParameterCategory = (t: (key: string) => string): ParameterCategory => ({
    id: "formula-fields",
    name: t("formula_picker.category_name"),
    type: "formulas",
    defaultExpanded: true,
    items: FORMULA_PICKER_TOKENS.map((id) => ({ id, name: id, paramType: "formulas" as const })),
});
